export function getMaterialsFromStorage() {
  try {
    const raw = localStorage.getItem("materialsDescription");
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export const isHouseholdMaterial = (referenceName) =>
  String(referenceName || "").startsWith("hw_");

/**
 * Matériaux de tri en erreur non autorisés pour un flux, filtrés pro ou ménager.
 */
function getUnauthorizedMaterialsForFlow(waste, streamType) {
  const authorized = new Set(
    (waste?.authorizedMaterial || [])
      .map((m) => (m?.value ?? m?.referenceName ?? "").toString().toLowerCase())
      .filter(Boolean),
  );

  const all = getMaterialsFromStorage();
  return all.filter((m) => {
    if (!m?.isActiveSortingError) return false;
    const ref = (m?.referenceName ?? "").toString().toLowerCase();
    if (authorized.has(ref)) return false;
    const hw = isHouseholdMaterial(ref);
    return streamType === "hw" ? hw : !hw;
  });
}

/**
 * Compte les catégories parentes distinctes + libellés pour le popover (ex. « Cartons (3) »).
 */
export function getUnauthorizedCategorySummary(
  waste,
  streamType,
  formatLabel,
  locale,
) {
  const materials = getUnauthorizedMaterialsForFlow(waste, streamType);
  const countsByCategory = new Map();

  materials.forEach((m) => {
    const key = m?.parentCategory;
    if (!key) return;
    countsByCategory.set(key, (countsByCategory.get(key) || 0) + 1);
  });

  const categoryKeys = [...countsByCategory.keys()].sort((a, b) => {
    // « Autres » (other) toujours en dernier, quelle que soit la langue.
    const aIsOther = a === "other";
    const bIsOther = b === "other";
    if (aIsOther !== bIsOther) return aIsOther ? 1 : -1;
    const labelA = typeof formatLabel === "function" ? formatLabel(a) : a;
    const labelB = typeof formatLabel === "function" ? formatLabel(b) : b;
    return String(labelA).localeCompare(String(labelB), locale || undefined, {
      sensitivity: "base",
    });
  });

  const items = categoryKeys.map((key) => {
    const label = typeof formatLabel === "function" ? formatLabel(key) : key;
    const count = countsByCategory.get(key) || 0;
    return {
      key,
      label,
      count,
      display: `${label} (${count})`,
    };
  });

  const totalCount = items.reduce((sum, item) => sum + item.count, 0);

  return {
    count: totalCount,
    categoryCount: categoryKeys.length,
    labels: items.map((item) => item.display),
    items,
    categoryKeys,
    materials,
  };
}

/** Libellé unité liste — coût toujours exprimé en tonne (cf. formulaire flux). */
export function formatTreatmentCost(waste, unitLabel = "tonne") {
  const cost = waste?.treatmentCostFull;
  const hasCost = cost !== undefined && cost !== null && cost !== "";
  if (!hasCost) return "—";
  return `${cost}€ / ${unitLabel}`;
}

export function formatDensity(waste) {
  const density = waste?.density;
  if (density === undefined || density === null || density === "") return "—";
  return `${density} kg/m³`;
}
